import React from 'react';
import {
    GeckoModal,
    GeckoModalService,
} from 'ui';
import UserAvailability from "../../utilities/userAvailability";
import { renderError } from "../../services/gecko-error";

const AvailabilityModal = (props) => {
    const { adminFullName, timestamp, user} = props;
    const footerBtns = [
        {
            name: 'Close',
            icon: 'far fa-times',
            type: 'default',
            handler: () => {
                new GeckoModalService().close()
            },
        },
        {
            name: 'Become available',
            icon: 'far fa-user-check',
            type: 'primary',
            handler: () => {
                UserAvailability.updateUserAvailability(user, true).catch(renderError);
                new GeckoModalService().close()
            },
        },
    ];

    return (
        <GeckoModal
            name= {'Your status was changed'}
            children={
            <div>
            <p>Your status has been changed to <b>Unavailable</b> by {adminFullName} at {timestamp}.</p>
            </div>
            }
            btns={footerBtns}
        >
        </GeckoModal>
    );
}

export default AvailabilityModal; 